<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="SALES QUOTE CREATE" >
          <template slot="actions">
            <vs-button v-can="'create-edit-sales-quote'" icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary" type="border">
              Back to sales quote list
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <form autocomplete="off">

          <vs-table v-if="is_table_display" :hoverFlat="true" id="sample_list" v-can="'create-edit-sales-quote'"  :data="staff"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container" noDataText="Search and add product to your cart">

              <template slot="header">

                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search here"
                          v-model="filters['search']" @keyup.enter.prevent=""
                          class="is-label-placeholder px-3 pb-5 w-full md:w-1/2 xl:w-1/7 rounded-full" />
                <vs-button id="place_order" :disabled="cartItems.length === 0" v-can="'create-edit-sales-quote'" icon-pack="feather" icon="icon-shopping-cart" @click="onClickPlaceOrder" class="mr-12" color="primary" type="filled">
                  Create sales quote ({{cartItems.length}} products)
                </vs-button>
              </template>

              <template slot="thead">
                <vs-th sort-key="formulation_code">ITS PRODUCT CODE/NAME</vs-th>
                <vs-th sort-key="name">CUSTOMER ITEM CODE/NAME</vs-th>
               <vs-th width="10%">PACK SIZE</vs-th>
                <vs-th width="10%">QUANTITY (KG)</vs-th>
                <vs-th width="10%" class="">UNIT PRICE (KG/{{account_currency}})</vs-th>
                <vs-th v-if="!__isCurrencyGbp(account_currency)" width="10%" class="">UNIT PRICE (KG/GBP)</vs-th>
                <vs-th width="10%" class="">INCOTERM</vs-th>
                <vs-th width="10%" class="">TOTAL PRICE ({{account_currency}})</vs-th>
                <vs-th width="20%" class="" v-can="'create-edit-sales-quote'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :state="tr.errors.length > 0 ? 'danger' : null" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    <span class="font-bold">{{ data[indextr].formulation_code}}</span> <br>
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td>
                    <div v-if="data[indextr].customer_item_code !== 'N/A'">
                      <span class="font-bold">{{ data[indextr].customer_item_code}}</span> <br>
                      {{ data[indextr].customer_item_name }}
                    </div>
                    <div v-else> N/A </div>
                  </vs-td>

                 <vs-td>
                  <v-select  v-on:input="onChangePackSize(data[indextr],  indextr)"  :clearable="true" placeholder=""  v-model="data[indextr].pack_size" :appendToBody="true"
                               :options="pack_size_options" label="size" :reduce="option => option.size"
                               :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                 </vs-td>

                  <vs-td :data="data[indextr].quantity">
                    <ValidationProvider v-if="data[indextr].type === 'List'" :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'moq:'+data[indextr].min_order_quantity" v-slot="{ errors }">
                      <vs-input v-on:input="onChangeQty(data[indextr],  indextr)"  type="text" v-model="data[indextr].quantity" class="w-full"
                                  :name="indextr+'quantity'"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                    <span class="ml-2" v-if="['Contract', 'Bespoke'].includes(data[indextr].type) && !data[indextr].is_tier">
                      {{ data[indextr].quantity}}
                    </span>
                    <span class="ml-2" v-if="['Contract', 'Bespoke'].includes(data[indextr].type) && data[indextr].is_tier">
                      <span v-for="(qty_obj, index) in data[indextr].quantity_array" :key="index">
                        {{ qty_obj.quantity_from }} - {{ qty_obj.quantity_to }} <br>
                      </span>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].unit_price">
                    <span v-if="!data[indextr].is_tier">
                      {{data[indextr].unit_price}}
                    </span>
                    <span v-if="data[indextr].is_tier">
                      <span v-for="(price_obj, index) in data[indextr].price_array" :key="index">
                        {{ price_obj.price }} <br>
                      </span>
                    </span>
                  </vs-td>

                  <vs-td  v-if="!__isCurrencyGbp(account_currency)" :data="data[indextr].price">
                    {{ calculateProductListPrice(data[indextr].pe_g, data[indextr].quantity) }}
                  </vs-td>

                  <vs-td :data="data[indextr].incoterm">
<!--                    {{ is_uk_based_customer ? 'DDP-UK' : data[indextr].incoterm }}-->
                    <v-select v-on:input="onChangeQty(data[indextr],  indextr)"  :clearable="true" placeholder=""  v-model="data[indextr].incoterm" :appendToBody="true"
                               :options="incoterms" label="code" :reduce="option => option.code"
                               :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                  </vs-td>

                  <vs-td>
                    <span v-if="!data[indextr].is_tier">
                      {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                    </span>
                    <span v-if="data[indextr].is_tier">
                      N/A
                    </span>
                  </vs-td>


                  <vs-td v-can="'create-edit-sales-quote'">
                    <div class="vx-row">
                      <vx-tooltip :text="`Remove ${tr.formulation_code} from cart`" position="top">
                        <vs-button class="mr-2" :id="'remove_button'+''+ indextr" v-if="checkItemInCart(data[indextr])" @click.native="onClickRemoveFromCart(data[indextr].id, indextr)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['Contract', 'Bespoke'].includes(data[indextr].type)" text="Add/Update price tiers" position="top">
                        <vs-button :id="'add_button'+''+ indextr" @click.native="onClickCalculatePrice(data[indextr], indextr)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus">Price tiers</vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].errors.length > 0" text="View Errors" position="top" class="ml-2">
                        <vs-button @click.stop="onClickViewErrors(data[indextr].errors)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-alert-triangle"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].errors.length > 0 && $can('view-formulations')" text="View Product" position="top" class="ml-2">
                        <vs-button @click.stop="onClickViewProduct(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="data[indextr].type !== 'List'" :text="data[indextr].type + ' Price'" position="top" class="ml-2">
                        <vs-button @click.stop=""
                                   size="small" color="warning" type="filled">
                          {{ data[indextr].type === 'Bespoke' ? 'B' : data[indextr].type === 'Contract' ? 'C' : ''}}
                        </vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
<!--                <vs-tr v-if="staff.length > 0">-->
<!--                  <vs-td style="font-weight: bolder">Total</vs-td>-->
<!--                  <vs-td></vs-td>-->
<!--                  <vs-td></vs-td>-->
<!--                  <vs-td></vs-td>-->
<!--                  <vs-td v-if="!__isCurrencyGbp(account_currency)"></vs-td>-->
<!--                  <vs-td></vs-td>-->
<!--                  <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>-->
<!--                  <vs-td></vs-td>-->
<!--                </vs-tr>-->
              </template>


            </vs-table>
              </form>
            </ValidationObserver>

          </div>
        </vx-card>
      </div>
    </div>
    <create-customer-sales-quote-pop-up v-bind:account_currency="account_currency" ref="createCustomerSalesQuotePopUp"/>
    <calculate-product-sales-quote-price-pop-up @changeQtyLayer="changeQtyLayer" ref="calculateProductSalesQuotePricePopUp" v-bind:account_currency="account_currency"/>
    <rm-catalogue-error-pop-up ref="rmCatalogueErrorPopUp"/>
    <vs-prompt
      title="Custom Pack Size"
      acceptText="Save"
      @cancel="active_custom_pack_size_prompt = false"
      @accept="submitCustomPackSize"
      @close="active_custom_pack_size_prompt = false"
      :active.sync="active_custom_pack_size_prompt">
      <div class="con-exemple-prompt">
        <span>Enter the value</span>
        <vs-input v-model="custom_pack_size_val" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'
  import CalculateProductSalesQuotePricePopUp
    from "@/components/popups/customer/sales-quote/CalculateProductSalesQuotePricePopUp";
  import CreateCustomerSalesQuotePopUp from "@/components/popups/customer/sales-quote/CreateCustomerSalesQuotePopUp";
  import RmCatalogueErrorPopUp from "@/components/popups/inventory/rm-orders/RmCatalogueErrorPopUp";

  const CustomerRepository = RepositoryFactory.get('customer')
  const IncotermRepository = RepositoryFactory.get('incoterm')
  const PackSizeRepository = RepositoryFactory.get('pack_size')

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        // customerId: '',
        cartItems: [],
        isHaveCreditAccount: false,
        addresses: [],
        is_uk_based_customer: false,
        default_incoterm: 'DDP UK',
        pack_size_options: [],
        customer_pack_sizes: [],
        temp_data: {},
        active_custom_pack_size_prompt: false,
        custom_pack_size_val: 0,
        is_table_display: true,
      }
    },
    props: {
      account_currency  : {
        type: String,
        default: '',
      },
      customer_id: {
        type: String,
      },
      sample_order_id:{
        type: String
      },
    },
    components: {
      'v-select': vSelect,
      CreateCustomerSalesQuotePopUp,
      CalculateProductSalesQuotePricePopUp,
      RmCatalogueErrorPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages, Calculations],
    async mounted () {
      this.customerId = this.$route.params.id
      await this.getAddresses()
      await this.getIncoterms()
      await this.getPackSizeList()
      await this.getCustomerPackSizeSelection()
    },
    methods: {
      async refreshData () {
        await this.loadOnlyCartItemCatalogue()
        this.$emit('back')
      },
      async onlyRefreshData() {
        await this.loadOnlyCartItemCatalogue()
      },
      async loadOnlyCartItemCatalogue() {
        try {
          await this.getItemsInItemsCart()
          const { data } = await CustomerRepository.getListOfCartProductCatalogueSalesQuote(
            this.customerId,
            {  formulation_ids: this.cartItems.map((x) => x.formulation_id) } , 0
          )
          let staff_arr = data.data
          staff_arr = staff_arr.map((n) => {
            const second =  this.cartItems.find((m) => n.id === m.formulation_id )
            if(!!second) {
              n.quantity = second.quantity
              n.quantity_from = second.quantity_from
              n.quantity_to = second.quantity_to
              n.unit_price = second.price
              n.incoterm = second.incoterm
              n.is_tier = second.is_tier
              n.quantity_array = second.quantity_array
              n.price_array = second.price_array
              n.pack_size = second.pack_size ? second.pack_size : (this.isCustomerHasPackSize(n.formulation_type) ? this.customerPackSizeFactory(n.formulation_type) : this.pack_size_options[0].size)
            }
            return n
          })
          this.staff = staff_arr.filter((n) => !!n.quantity)

        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async loadProductCart() {

        try {
          await this.$vs.loading({
            container: '#sample_list',
            scale: 0.45
          })
          const {data} = await CustomerRepository.getListOfProductCatalogueSalesQuote(this.customerId, this.filterQuery)
          await this.getItemsInItemsCart()
          this.staff =  data.data.map((n) => {
            n.unit_price = ''
            return n
          }).sort((a, b) => {
            if (a.type !== "List" && b.type === "List") {
              return -1; // a comes before b
            }
            if (a.type === "List" && b.type !== "List") {
              return 1; // b comes before a
            }
            return 0; // keep their order otherwise
          })
          if (!!this.filters['search']) {
            this.staff = this.staff.map((n) => {
              const second =  this.cartItems.find((m) => n.id === m.formulation_id )
              if(!!second) {
                n.quantity = second.quantity
                n.quantity_from = second.quantity_from
                n.quantity_to = second.quantity_to
                n.unit_price = second.price
                n.incoterm = second.incoterm
                n.is_tier = second.is_tier
                n.quantity_array = second.quantity_array
                n.price_array = second.price_array
                n.pack_size = second.pack_size
              } else {
                n.pack_size = this.isCustomerHasPackSize(n.formulation_type) ? this.customerPackSizeFactory(n.formulation_type) : null
              }
              n.incoterm = n.incoterm ? n.incoterm : this.default_incoterm
              return n
            })
          } else {
            let staff_arr = this.staff
            staff_arr = staff_arr.map((n) => {
              const second =  this.cartItems.find((m) => n.id === m.formulation_id )
              if(!!second) {
                n.quantity = second.quantity
                n.quantity_from = second.quantity_from
                n.quantity_to = second.quantity_to
                n.unit_price = second.price
                n.incoterm = second.incoterm
                n.is_tier = second.is_tier
                n.quantity_array = second.quantity_array
                n.price_array = second.price_array
              } else {
                n.incoterm = this.default_incoterm
              }
              return n
            })
            this.staff = staff_arr.filter((n) => !!n.quantity)
          }


        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#sample_list > .con-vs-loading')
      },

      async onClickCalculatePrice(data, index) {
        if(data.price.length === 0) {
          alert('error in price tiers')
          return
        }
        await this.$refs.calculateProductSalesQuotePricePopUp.openPopup(data, index, this.customerId)
      },

      async onClickAddToCart(data, indextr) {
        await this.$vs.loading({
          container: `#sample_list`,
          scale: 0.45
        })
        try {
          const payload = {}
          payload.customer_id = this.customerId
          payload.formulation_id = data.id
          payload.customer_product_code = data.customer_item_code
          payload.product_code_name = `${data.formulation_code} ${data.name}`

          if(!data.is_tier) {
            payload.quantity_array = [ { quantity: data.quantity } ]
            payload.price_array = [ { price: (Number(data.unit_price)).toFixed(2) } ]
            payload.quantity = data.quantity
            payload.price = (Number(data.unit_price)).toFixed(2)
          } else {
            payload.quantity_array = data.quantity_array
            payload.price_array = data.price_array
            payload.quantity = 'tier'
            payload.price = 'tier'
          }
          payload.quantity_from = data.quantity_from ?  data.quantity_from : data.quantity
          payload.quantity_to = data.quantity_to ?  data.quantity_to : data.quantity
          payload.is_tier = data.is_tier
          payload.type = data.type
          payload.incoterm = data.incoterm ? data.incoterm : this.default_incoterm
          payload.pack_size = data.pack_size ? data.pack_size : (this.isCustomerHasPackSize(data.formulation_type) ? this.customerPackSizeFactory(data.formulation_type) : this.pack_size_options[0].size)
          payload.lead_time = ''
          payload.estimated_yearly_volume = ''
          payload.valid_from = ''
          payload.valid_to = ''

          // await CustomerRepository.addFormulationsToProductCart(payload)
          this.cartItems.push(payload)
          await this.getItemsInItemsCart()
          this.filters['search'] =  ''
          this.showSuccessMessage('Sales quote updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async onClickRemoveFromCart(id, indextr) {
        await this.$vs.loading({
          container: `#remove_button${indextr}`,
          scale: 0.45
        })
        try {
          this.cartItems = this.cartItems.filter((x) => {
            return x.formulation_id !== id
          })
          // const search = this.cartItems.find((n) => n.formulation_id === id )
          // await CustomerRepository.removeFormulationsFromProductCart(search.id)
          await this.loadOnlyCartItemCatalogue()
          this.showSuccessMessage('Sales quote updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#remove_button${indextr} > .con-vs-loading`)
      },
      async onClickUpdateFromCart(data, indextr) {
        await this.$vs.loading({
          container: `#sample_list`,
          scale: 0.45
        })
        try {
          // const search = this.cartItems.find((n) => n.formulation_id === data.id )
          // const payload = {quantity: data.quantity, price: data.unit_price, incoterm: data.incoterm}
          // await CustomerRepository.updateFormulationsQuantityInProductCart(search.id, payload)
          this.cartItems = this.cartItems.map((x) => {
            if(x.formulation_id === data.id) {



              if(!data.is_tier) {
                x.quantity_array = [ { quantity: data.quantity } ]
                x.price_array = [ { price: (Number(data.unit_price)).toFixed(2) } ]
                x.quantity = data.quantity
                x.price = Number(data.unit_price).toFixed(2)
              } else {
                x.quantity_array = data.quantity_array
                x.price_array = data.price_array
                x.quantity = 'tier'
                x.price = 'tier'
              }

              x.quantity_from = data.quantity_from ? data.quantity_from : data.quantity
              x.quantity_to = data.quantity_to ? data.quantity_to : data.quantity
              x.is_tier = data.is_tier
              x.incoterm = data.incoterm
              x.pack_size = data.pack_size ? data.pack_size : ''
            }
            return x
          })
          // await this.loadProductCart()
          this.filters['search'] =  ''
          this.showSuccessMessage('Sales quote updated')
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async getItemsInItemsCart() {
        // await this.$vs.loading({
        //   container: '#place_order',
        //   scale: 0.45
        // })
        // try {
        //   const {data} = (await CustomerRepository.getItemsInProductCart(this.customerId)).data
        //   this.cartItems = data
        // }catch (e) {
        //   this.convertAndNotifyError(e)
        // }
        // this.$vs.loading.close('#place_order > .con-vs-loading')
      },
      async onClickPlaceOrder() {
        await this.$refs.createCustomerSalesQuotePopUp.openPopup(this.customerId,this.sample_order_id, this.is_uk_based_customer, this.cartItems)
      },

      filterQueryUpdate (){
        if(this.filters.search) {
          this.loadProductCart()
        } else {
          this.loadOnlyCartItemCatalogue()
        }
      },
      checkItemInCart: function (object) {
        const arr = this.cartItems.filter((n) => n.formulation_id === object.id)
        return arr.length > 0
      },
      totalCalculator() {
        let total = 0;
        this.staff.forEach((m) => {
          if (!!m.quantity && Number(m.unit_price) > 0) {
            total = total + Number(m.unit_price) * Number(m.quantity)
          }

        })
        return total.toFixed(2)
      },
      async onChangeQty(row_data, index) {
        let data = {}
        Object.assign(data, row_data)
       
        if (typeof data.quantity === 'undefined' || data.quantity === null) {
        if (Array.isArray(data.quantity_array) && data.quantity_array.length > 0) {
            // If 'qty' is undefined or null, but 'quantity_array' exists and is a non-empty array, continue execution
            // Continue with further logic without returning or terminating early
        } else {
            return null;
        }
    }
        
        data.type = data.type === 'List' ? 'price' : 'contract'
        if(data.type === 'price') {
          let unit_price = this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate)
          this.staff[index].unit_price =  unit_price
          data.unit_price =  unit_price
          data.is_tier = false
        }
        const find = this.cartItems.find((m) => m.formulation_id === data.id)
        if(find) {
          this.updateCart(data, index, this)
        } else {
          this.addCart(data, index, this);
        }
      },
      async changeQtyLayer(e) {
        await this.onChangeQty(e.data, e.index)
      },
      addCart: _.debounce( async (data, index, vm) => {
        await vm.onClickAddToCart(data, index)
        await vm.loadOnlyCartItemCatalogue()
      }, 1500),
      updateCart: _.debounce( async (data, index, vm) => {

        // if(!data.quantity) { return null }
        await vm.onClickUpdateFromCart(data, index)
        await vm.loadOnlyCartItemCatalogue()
      }, 1500),
      async getAddresses() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.customerId)).data.data;
        const find = this.addresses.find((x) => x.country === 'United Kingdom')
        this.is_uk_based_customer = !!find;
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      async getIncoterms() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        try {
          const {data} = await IncotermRepository.getListOfIncoterms(1, '', 100, '')
          this.incoterms = [...data.data].sort((a, b) => (a.code === 'DDP UK' ? -1 : b.code === 'DDP UK' ? 1 : 0))
          const find_default_incoterm = this.incoterms.find((x) => x.is_default )
          this.default_incoterm = find_default_incoterm ? find_default_incoterm.code : 'DDP UK'
        } catch(e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      onClickViewErrors(errors) {
        this.$refs.rmCatalogueErrorPopUp.openPopUp(errors, 'PRODUCT')
      },
      onClickViewProduct(id) {
        let route = this.$router.resolve({path: `/pages/formulations/${id}`});
        window.open(route.href, '_blank');
      },
      async getCustomerPackSizeSelection() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerRepository.getCustomerDetails(this.customerId)).data
          this.customer_pack_sizes = data.pack_sizes && data.pack_sizes instanceof Array ? data.pack_sizes.map((x) => {
            x.size = this.__removeTrailingZeros(x.size)
            return x
          }) : []
        } catch(e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      customerPackSizeFactory(formulation_type) {
        let find = this.customer_pack_sizes.find((x) => x.formulation_type ===  formulation_type)
        return find && find.size !== null ? find.size : '0.000'
      },
      isCustomerHasPackSize(formulation_type) {
        let find = this.customer_pack_sizes.find((x) => x.formulation_type ===  formulation_type)
        return !!find
      },
      async getPackSizeList() {
        await this.$vs.loading({
          container: '#sample_list',
          scale: 0.45
        })
        try {
          const {data} = await PackSizeRepository.getListOfPackSize(1, '', 100, '')
          this.pack_size_options =  data.data.map((x) => {
            x.size = this.__removeTrailingZeros(x.size)
            return x
          })
          this.pack_size_options.push({ size: 'custom size' })
        } catch(e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close(`#sample_list > .con-vs-loading`)
      },
      onChangePackSize(data, index) {
        if(data.pack_size !== 'custom size') {
          this.is_table_display = !this.is_table_display
          this.is_table_display = !this.is_table_display
          this.onChangeQty(data, index)
        } else {
          this.temp_data = { data, index }
          this.custom_pack_size_val = 0
          this.active_custom_pack_size_prompt = !this.active_custom_pack_size_prompt
        }
      },
      submitCustomPackSize() {
        try {
          this.active_custom_pack_size_prompt = false
          this.temp_data.data.pack_size = this.__removeTrailingZeros(this.custom_pack_size_val)
          this.is_table_display = !this.is_table_display
          this.is_table_display = !this.is_table_display
          this.onChangeQty(this.temp_data.data, this.temp_data.index)
        } catch (error) {
          this.convertAndNotifyError(error);
        }
      },
    },
    watch : {
      page(){
        this.loadProductCart()
      }
    },
    computed: {
      customerId: function () {
        return this.customer_id
      },
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
